import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Packages } from "src/store";
import LazyLoad from "vanilla-lazyload";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";
import { StringService, _ } from "src/services";

export const PaymentPackage: React.FC = () => {
    //#region dependencies

    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#endregion

    //#region effects

    useEffect(() => {

        const updateImages = () => {
            const lazyload = new LazyLoad({
                elements_selector: ".lazy",
                callback_error: (element: HTMLElement) => {
                    const placeholder = element.getAttribute("data-placeholder");
                    if (placeholder) element.setAttribute("src", placeholder);
                }
            });

            lazyload.update();
        };

        if (packages.order) {
            updateImages();
        }

    }, [packages.order]);

    //#endregion



    const renderContent = () => {
        if (packages.loading && !packages.order) return (
            <>
                <div className="shimmer"></div>
                <div className="shimmer mt-3"></div>
            </>
        );

        if (!packages.order) return null;

        const {
            amount, color, crossedAmount, discountPercent, durationType,
            packageLogo, packageTitle, partner
        } = packages.order;

        return (
            <>
                <div className="d-flex justify-content-start align-items-center">
                    <img data-placeholder={phPackage}
                        src={phPackage}
                        data-src={packageLogo} alt={packageTitle}
                        className="payment-box__icon lazy" />
                    <span className="payment-box__title">
                        <span>{packageTitle}</span>
                    </span>
                </div>
                <div className="d-flex justify-content-start align-items-center mt-3 profile-info">
                    <div className="payment-box__xtitle d-flex justify-content-center align-items-center rtl">
                        <span>{durationType}</span>
                        {
                            partner && partner.partnerName &&
                            <>
                                <span className="mx-2">+</span>
                                <span style={{ color: partner.colorCode }}>{partner.productName} {partner.partnerName}</span>
                            </>
                        }
                    </div>
                    <div className="flex-1 d-flex align-items-center">
                        {
                            discountPercent > 0 &&
                            <span style={{ backgroundColor: color }} className="payment-box__discount mx-2">٪{discountPercent}</span>
                        }
                        <div className="flex-1"></div>
                        <div className="payment-box__total-price green-fcolor">{StringService.toPrice(amount)} {_("currency")}</div>
                        {
                            discountPercent > 0 && crossedAmount > 0 &&
                            <div className="payment-box__discount-price mr-2">{StringService.toPrice(crossedAmount)} {_("currency")}</div>
                        }
                    </div>
                </div>
            </>
        );
    };


    return (
        <>
            <div className="payment-package-info d-flex flex-column">
                {renderContent()}
            </div>
        </>
    );

};